
































































































































import Vue from 'vue';
import _ from 'lodash';
import { API, Auth } from "aws-amplify";
import { Constants } from "@/api-constants";
import { mapState, mapGetters } from 'vuex';
import AuthLogin from '@/components/auth/auth-login.vue';
import PropertyResultsCards from '@/components/property/property-results-cards.vue';
import PropertyResultsCardList from '@/components/property/property-results-card-list.vue';
import PropertyResultsCardTile from '@/components/property/property-results-card-tile.vue';
import PropertyMenu from '@/components/property/property-menu.vue';

export default Vue.extend({

  name: 'ViewpointsResults',

  components: {
    'auth-login': AuthLogin,
    'property-results-cards': PropertyResultsCards,
    'property-results-card-tile': PropertyResultsCardTile,
    'property-results-card-list': PropertyResultsCardList,
    'property-menu': PropertyMenu,
  },

  props: {},

  data() {
    return {
      packageId: this.$store.getters.getPackageId,
      myViewpoints: [] as any,
      sharedViewpoints: [] as any,
      favoritesProp: this.$store.getters.getFavourites,
      updatedFlag: 0,
      trashConfirm: false,
      trashId: '' as any,
      trashName: '' as any,
    };
  },

  created() {
    this.loadViewpoints();
  },

  mounted() {

  },

  watch: {
    getIsLoggedIn(newVal, oldVal) {
      console.log('Watch > getIsLoggedIn: ' + newVal);
    },
    getInstanceId(newVal, oldVal) {
      this.loadViewpoints();
    },
    getViewpoints(newVal, oldVal) {
      this.loadViewpoints();
    },
    getFavourites(newVal, oldVal) {
      this.favoritesProp = newVal;
    },
  },

  computed: {
    // mix the getters into computed
    ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),
    getViewpoints(): any[] {
      return this.getVpInstances;
    },
    buttonStyle(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'buttonTight';
        default:
          return '';
      }
    },
  },

  methods: {

    async makeCurrentViewpoint(viewpointId: any) {
      this.$store.dispatch('setViewpointId', viewpointId);
    },

    async trashViewpoint(viewpointId: any, viewpointName: any) {
      this.trashId = viewpointId;
      this.trashName = viewpointName;
      this.trashConfirm = true;
    },

    async deleteInstance() {
      this.$store.dispatch('deleteInstance', this.trashId);
      this.trashConfirm = false;
    },

    async loadViewpoints() {
      this.myViewpoints = this.getVpInstances;
      if (this.getViewpoints.length) {
        let myViewpoints: any[] = [];
        for (const viewpoint of this.myViewpoints) {
          // let res: any = {};
          // res['viewpointId'] = viewpoint.viewpointId;
          let selected: any = await this.getSelected(viewpoint.viewpointId);
          let scored: any = await this.getProperties(viewpoint.viewpointId);
          viewpoint['selected'] = _.map(selected).slice(0, 3);
          viewpoint['scored'] = scored;
          viewpoint['favorites'] = _.map(selected, 'id');
          console.log('[[[[[--viewpoint--]]]]]');
          console.log(viewpoint);
          myViewpoints.push(viewpoint);
        }
        this.myViewpoints = myViewpoints;
      }
    },

    getGroupId(factorGroups: object, factorGroupName: any): any {
      let factorGroup: any[] = _.filter(factorGroups, ['name', factorGroupName]);
      if (factorGroup.length) {
        return factorGroup[0].id;
      } else {
        console.log('Factor Group "' + factorGroupName + '" was not found.');
        return false;
      }
    },

    addDetails(choices: any, factorGroups: any[]): any[] {
      // Fill the <factorGroup>Id arrays
      const lifestyleGroupArray: any[] = [];
      lifestyleGroupArray.push(this.getGroupId(factorGroups, 'Lifestyle'));
      const propertyGroupArray: any[] = [];
      propertyGroupArray.push(this.getGroupId(factorGroups, 'Property'));
      const geographyGroupArray: any[] = [];
      geographyGroupArray.push(this.getGroupId(factorGroups, 'Geography'));

      const lifestyleGroupId: number = this.getGroupId(factorGroups, 'Lifestyle');
      const propertyGroupId: number = this.getGroupId(factorGroups, 'Property');
      const geographyGroupId: number = this.getGroupId(factorGroups, 'Geography');
      // loop through the choices and create a better pkg for displaying
      let favouriteRank = 0;
      for (const choice of choices) {
        // extract the top contributing "lifestyle" factors and add to the choices[] array
        const lifestyleFactors: any[] = _.filter(choice.choiceFactors, {'groups': lifestyleGroupArray});
        choice['factors'] = _.orderBy(lifestyleFactors, [function (f: any) {
          return (f.score * f.weight)
        }], ['desc']);
        // extract the Property details and add to the choices[] array
        const propertyFactors: any[] = _.filter(choice.choiceFactors, {'groups': propertyGroupArray});
        choice['property'] = _.map(propertyFactors);
        // extract the Lat/Long and add to the choices[] array
        const geographyFactors: any[] = _.filter(choice.choiceFactors, {'groups': geographyGroupArray});
        const lat: any[] = _.filter(_.map(geographyFactors), {'name': 'Latitude'});
        const long: any[] = _.filter(_.map(geographyFactors), {'name': 'Longitude'});
        const location: any = {};
        location['lat'] = Number(lat[0].value);
        location['lng'] = Number(long[0].value);
        choice['position'] = location;
        choice['favouriteRank'] = favouriteRank;
        favouriteRank++;
      }
      return choices;
    },

    load(instanceId: string): any {
      this.getSelected(instanceId)
        .then(response => {
          console.log('LOAD:');
          console.log(response);
          return response;
        });
    },

    async getSelected(instanceId: string) {
      let list: any[] = [];
      let path = '/core/selected/choices/'
        + this.packageId
        + '/'
        + instanceId
        + '/favourite';
      // asynchronous code, using synchronous code structure
      // as opposed to Promise.then().catch() (better stack tracing and performance)
      try {
        const response: any = await API.get(Constants.API_NAME, path, {});
        list = _.map(_.orderBy(response, [function (f: any) {
          return f.rank
        }]), 'id');
        console.log('getSelected() RESPONSE:');
        console.log(response);
      } catch (error) {
        console.log('getSelected() ERROR: ' + error);
      }
      if (list.length) {
        const returnVal = await this.getProperties(instanceId, list);
        console.log('returnVal: ');
        console.log(returnVal);
        return returnVal;
      } else {
        console.log('getSelected() > empty return');
        return false;
      }
    },

    async getProperties(instanceId: string, list?: string[]): Promise<any> {
      const path: string = '/core/scoring/choices/'
        + this.packageId;
      +'/'
      + instanceId;
      if (list) {
        let myInit: object = {
          queryStringParameters: {
            choiceId: list
          }
        };
        return API.get(Constants.API_NAME, path, myInit)
          .then(response => {
            console.log('[ getProperties() > Selected ]');
            console.log(response);
            const choices: any[] = _.sortBy(response.choices, [function (f: any) {
              return f.rank
            }]);
            // const choices: any[] = _.map(response.choices);
            if (choices.length) {
              const factorGroups: any = choices[0].factorGroups;
              const sortedChoices: any = this.addDetails(choices, factorGroups);
              console.log('[ getProperties() > Favorites Top 3 ]');
              console.log(sortedChoices);
              return sortedChoices;
            } else {
              return false;
            }
          })
          .catch(error => {
            console.log('[ getProperties() > Favorites Top 3 ] ERROR: ' + error);
          })
          .finally(() => {
          });
      } else {
        let myInit: object = {
          queryStringParameters: {  // OPTIONAL
            pageSize: 18,
            pageOffset: 0
          }
        }
        return API.get(Constants.API_NAME, path, myInit)
          .then(response => {
            console.log('[ getProperties() > Scored Top 3 ] RESPONSE: ');
            console.log(response);
            let choices: any[] = _.orderBy(response.choices, [(f: any) => {
              return f.score
            }], ['desc']);
            // const choices: any[] = _.map(response.choices);
            const factorGroups: any = choices[0].factorGroups;
            let sortedChoices: any = this.addDetails(choices.slice(0, 3), factorGroups);
            return sortedChoices;
          })
          .catch(error => {
            console.log('[ getProperties() > Scored Top 3 ] ERROR: ' + error);
          })
          .finally(() => {
          });
      }
    },

    factorsUpdated() {
      this.updatedFlag++;
    },

  },


});

